import { useContext } from "react";

import { ComponentErrorBoundary } from "shared/components/atoms/ComponentErrorBoundary";
import { useIOSLimitations } from "shared/hooks/useIOSLimitations";
import CustomButtonCTA from "shared/providers/Layout/components/NewTopBar/components/atoms/CustomButtonCTA";
import { FeedButton } from "shared/providers/Layout/components/NewTopBar/components/atoms/FeedButton";
import { SearchButton } from "shared/providers/Layout/components/NewTopBar/components/atoms/SearchButton";
import { UserMenu } from "shared/providers/Layout/components/NewTopBar/components/atoms/UserMenu";
import { NotificationsButton } from "shared/providers/Layout/components/NewTopBar/components/organisms/NotificationsButton";
import { useTopbarContext } from "shared/providers/Layout/hooks/useTopbarContext";
import GlobalContext from "shared/providers/context/GlobalContext";
import { useAuthContext } from "shared/utils/hooks/useAuthContext";
import { useFeature } from "shared/utils/hooks/useFeature";

import GamificationInfos from "../../atoms/GamificationInfos";
import { OptionsContainer } from "./styles";

export const Options = () => {
  const { scrollIsOnTop, pageIsLoading } = useTopbarContext();
  const { loggedUser: user } = useAuthContext();
  const { state } = useContext(GlobalContext);
  const { shouldEnableIOSLimitations } = useIOSLimitations();

  const userIsLogged = !!user;
  const isGlobalGamificationEnabled = useFeature("f_global_gamification");
  const isNotificationsEnabled = useFeature("f_user_notifications");
  const isFeedEnabled = useFeature("f_feed");
  const isFeedConfigActive =
    state?.tenancy?.settings?.["social-network"]?.feedActive == 1;

  const gamificationData = state?.tenancy?.settings?.gamification;

  const isGamificationEnabled = gamificationData?.enableGamification == 1;

  const isAbleToShowGamificationScore =
    userIsLogged && isGlobalGamificationEnabled;

  return (
    <OptionsContainer
      buttonsShouldHaveBackground={scrollIsOnTop || pageIsLoading}
    >
      {isAbleToShowGamificationScore && isGamificationEnabled && (
        <ComponentErrorBoundary>
          <GamificationInfos />
        </ComponentErrorBoundary>
      )}
      <ComponentErrorBoundary>
        <SearchButton />
      </ComponentErrorBoundary>

      {isFeedEnabled && isFeedConfigActive && !shouldEnableIOSLimitations && (
        <ComponentErrorBoundary>
          <FeedButton />
        </ComponentErrorBoundary>
      )}

      {isNotificationsEnabled && (
        <ComponentErrorBoundary>
          <NotificationsButton />
        </ComponentErrorBoundary>
      )}

      <ComponentErrorBoundary>
        <CustomButtonCTA />
      </ComponentErrorBoundary>

      <ComponentErrorBoundary>
        <UserMenu />
      </ComponentErrorBoundary>
    </OptionsContainer>
  );
};
